import { useParams, useNavigate } from "react-router-dom";
import "./ProjectStory.css";

import i1 from "../images/1.png";
import i2 from "../images/2.jpg";
import i3 from "../images/3.png";
import i4 from "../images/4.png";
import i5 from "../images/5.png";
import i6 from "../images/6.jpg";
import i7 from "../images/7.jpg";
import i8 from "../images/8.jpg";
import i9 from "../images/9.jpg";
import i10 from "../images/10.png";
import i11 from "../images/11.png";
import i12 from "../images/12.jpg";
import i13 from "../images/13.jpg";
import i14 from "../images/14.jpg";
import i15 from "../images/15.png";
import i16 from "../images/16.png";

const PROJECTS = {
  dreamwalker: {
    title: "Dreamwalker",
    subtitle: "A journey through fragmented realities",
    image: i1,
    description: `
Dreamwalker was born from the idea of drifting between dreams.
I wanted the world to feel unstable — floating architecture,
soft lighting, and a sense of quiet loneliness.

This project pushed me to explore mood over realism.
`,
    tools: ["Blender", "Photoshop", "DaVinci Resolve"],
  },
  "stardust-tapestry": {
    title: "Stardust Tapestry",
    subtitle: "Celestial weave of light and memory",
    image: i1,
    description: `A celestial weave of light and memory, where constellations seem stitched into fabric.`,
    tools: ["Blender"],
  },
  "ares-forge": {
    title: "Ares' Forge",
    subtitle: "Molten metal and mythic red planet",
    image: i2,
    description: `Makeshift: molten metal and warrior dreams — heavy atmospheres and glowing red embers.`,
    tools: ["Blender"],
  },
  "crimson-bloom": {
    title: "Crimson Bloom",
    subtitle: "Floral forms at twilight",
    image: i3,
    description: `Makeshift: petals drenched in dusk; saturated color studies and soft volumetrics.`,
    tools: ["Blender"],
  },
  cimmeria: {
    title: "Cimmeria",
    subtitle: "Shadowed groves and whispered paths",
    image: i4,
    description: `Makeshift: a hush of shadowed woods, dense fog and muted light.`,
    tools: ["Blender", "Photoshop"],
  },
  "the-ever-watching-eye": {
    title: "The Ever-Watching Eye",
    subtitle: "A distant, observant presence",
    image: i5,
    description: `Makeshift: a sentinel of forgotten skies, composed to evoke curiosity and unease.`,
    tools: ["Blender", "Substance Painter", "After Effects"],
  },
  "shadows-last-stand": {
    title: "Shadow’s Last Stand",
    subtitle: "Twilight confrontation",
    image: i6,
    description: `Makeshift: last light before night takes hold; stark silhouettes and contrast.`,
    tools: ["Blender", "Photoshop", "DaVinci Resolve"],
  },
  "the-eclipse-gate": {
    title: "The Eclipse Gate",
    subtitle: "Threshold between sun and moon",
    image: i7,
    description: `Makeshift: a threshold where celestial bodies align — dramatic lighting and scale.`,
    tools: ["Blender", "Substance Painter"],
  },
  "tide-trotter": {
    title: "Tide Trotter",
    subtitle: "Coastal motion and rhythm",
    image: i8,
    description: `Makeshift: footsteps along the breathing shore; wet surfaces and reflective studies.`,
    tools: ["Blender", "Photoshop"],
  },
  enrosadira: {
    title: "Enrosadira",
    subtitle: "Land reclaimed by color",
    image: i9,
    description: `Makeshift: a landscape reclaimed by color; exploration of palettes and forms.`,
    tools: ["Blender", "Krita", "Photoshop"],
  },
  settle: {
    title: "Settle",
    subtitle: "Quiet corners and small moments",
    image: i10,
    description: `Makeshift: quiet corners and settling dust; intimate scale and lighting.`,
    tools: ["Blender", "Photoshop"],
  },
  bakehouse: {
    title: "Bakehouse",
    subtitle: "Warmth, texture, and routine",
    image: i11,
    description: `Makeshift: warmth, flour, and morning light; tactile materials and storytelling.`,
    tools: ["Blender", "Photoshop"],
  },
  leviathan: {
    title: "Leviathan",
    subtitle: "Deep forms and ancient motion",
    image: i12,
    description: `Makeshift: deep scales and ancient tides; large-form sculpting and mood.`,
    tools: ["Blender", "ZBrush", "Substance Painter"],
  },
  "feth-fiadat": {
    title: "Féth Fíadat",
    subtitle: "Whispered lore and distant hills",
    image: i13,
    description: `Makeshift: whispered lore from distant hills; atmospheric storytelling.`,
    tools: ["Blender", "Photoshop"],
  },
  petrichor: {
    title: "Petrichor",
    subtitle: "After the rain",
    image: i14,
    description: `Makeshift: the scent after a long-awaited rain; wet surfaces and fresh colors.`,
    tools: ["Blender", "Photoshop"],
  },
  maisonette: {
    title: "Maisonette",
    subtitle: "Small rooms with big stories",
    image: i15,
    description: `Makeshift: small rooms with big stories; detailed interiors and cozy lighting.`,
    tools: ["Blender", "Photoshop"],
  },
  "sinkers-and-suds": {
    title: "Sinkers and Suds",
    subtitle: "Everyday rituals rendered",
    image: i16,
    description: `Makeshift: sudsy rituals of the everyday; texture and motion in micro-scenes.`,
    tools: ["Blender", "Photoshop"],
  },
};

export default function ProjectStory() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const project = PROJECTS[slug];

  if (!project) return <div>Project not found</div>;

  return (
    <section className="story-cosmos">
      <button
        className="close-btn"
        title="Close"
        aria-label="Close and go to main page"
        type="button"
        onClick={(e) => {
          e.preventDefault();
          try {
            if (window.history.length > 2) {
              navigate(-1);
            } else {
              navigate("/", { replace: true });
            }
          } catch (err) {
            navigate("/", { replace: true });
          }
        }}
      >
        ✕
      </button>

      <button className="back-btn" onClick={() => navigate(-1)}>
        ← back to gallery
      </button>

      <div className="story-hero">
        <img src={project.image} alt={project.title} />
      </div>

      <div className="story-content">
        <div className="story-meta">
          <img
            className="story-thumb"
            src={project.image}
            alt={`${project.title} thumbnail`}
          />
          <div className="story-header">
            <h1>{project.title}</h1>
            <p className="story-sub">{project.subtitle}</p>
          </div>
        </div>

        <p className="story-desc">{project.description}</p>

        <div className="story-tools">
          <h3>Tools Used</h3>
          <ul>
            {project.tools.map((tool, i) => (
              <li key={i}>{tool}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
